// Console options - override of console.debug
console.debugging = true;

console.debug = function() {
    if (!console.debugging)
        return;
    console.log.apply(this, arguments);
};
